<template>
  <div class="wrapper">
    <ul class="current_user">
      <li>姓名：{{ selectdata.patientname }}</li>
      <li>就诊ID号：<span>{{ selectdata.patientId }}</span></li>
      <!-- <li>身份证：<span>{{ selectdata.idcardno.replace(/(\w{4})\w*(\w{4})/, "$1******$2") }}</span></li> -->
      <span @click="showNation = true" class="switch">切换就诊人</span>
      <img src="@/assets/record/jkm2.png" @click.stop="cardbtn(selectdata)"/>
    </ul>
    <div class="content">
      <div class="time_date">
        <span style="margin-right: 6px">{{ daystartDate }} 至 {{ dayendDate }}</span>
        <van-icon name="notes-o" size="26" @click="selectTime" />
      </div>
      <div v-if="showList">
        <ul class="records" v-for="item in recordList" :key="item.billNo" @click="push(item)">
          <li>缴费类别：<span>{{ item.chargeType }}</span></li>
          <li>&nbsp;总&nbsp;金&nbsp;额：<span>{{ item.costs }}</span> 元</li>
          <li>就诊时间：<span>{{ item.visitDate }}</span></li>
          <li>缴费时间：<span>{{ item.sfsj }}</span></li>
          <img src="@/assets/appointment/xsj_r.png">
        </ul>
      </div>
    </div>
    <div class="empty_cl" v-if="!showList">
      <img src="@/assets/bg/empty.png">
      <span>暂无缴费记录</span>
    </div>
    <van-calendar
      v-model="showMoreSel"
      type="range"
      @confirm="onConfirmMore"
      color="#318fe6"
      :min-date="minDate"
      :max-date="maxDate"
      :default-date="[new Date(daystartDate),new Date(dayendDate)]"
    />
    <van-popup v-model="showNation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirmNation"
        @cancel="showNation = false"
      />
    </van-popup>
    <judgment></judgment>
  </div>
</template>

<script>
import { selectVisitinfos, getPayedRecipe } from "@/request/api.js";
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      showNation: false,
      columns: [],
      selectdata: {
        idcardno: ""
      },
      showList: false,
      showMoreSel: false,
      minDate: new Date(),
      maxDate: new Date(),
      daystartDate: "",
      dayendDate: "",
      recordList: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == "/" || from.path == "/index"){
        vm.getVisitinfos();
      } else {
      }
    })
  },
  created() {
    
  },
  mounted() {
    // this.getVisitinfos();
  },
  methods: {
    // 获取所有就诊人
    async getVisitinfos() {
      let openid = sessionStorage.getItem("openid");
      let res = await selectVisitinfos({ openid });
      this.columns = res.data.obj;
      res.data.obj.forEach(item => {
        item.text = item.patientname;
        if (item.style == 1) {
          this.selectdata = item;
        }
      });
      this.getDate();
    },
    // 切换就诊卡
    onConfirmNation(value) {
      this.selectdata = value;
      this.showNation = false;
      this.getDate();
      this.Toast("切换成功");
    },
    // 查看电子卡
    cardbtn(item){
      sessionStorage.setItem("card", JSON.stringify(item));
      this.$router.push("/HealthCard");
    },
    // 获取门诊费用记录
    async getPayed(){
      let map = {
        endDate: this.dayendDate,
        patientID: this.selectdata.patientId,
        // patientID: 715545,
        startDate: this.daystartDate
      }
      let res = await getPayedRecipe(map);
      if(res.data.state == 200){
        res.data.obj.resultData.forEach(item => {
          item.visitDate = item.visitDate.replace(/\s{2}/g," ");
          item.visitDate = item.visitDate.split(" ")
          item.visitDate = item.visitDate[2] +'-'+ item.visitDate[0].toString().padStart(2,'0') +'-'+ item.visitDate[1].toString().padStart(2,'0')
          item.sfsj = item.sfsj.replace(/\s{2}/g," ");
          item.sfsj = item.sfsj.split(" ")
          item.sfsj = item.sfsj[2] +'-'+ item.sfsj[0].toString().padStart(2,'0') +'-'+ item.sfsj[1].toString().padStart(2,'0')
        });
        this.recordList = res.data.obj.resultData;
        this.showList = true;
      } else {
        this.showList = false;
      }
    },
    getDate(){
      this.minDate = new Date(this.$moment(new Date()).subtract(10, 'year').format('YYYY-MM-DD'));
      this.maxDate = new Date();
      this.daystartDate = this.$moment(new Date()).subtract(6, 'month').format('YYYY-MM-DD')
      this.dayendDate = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getPayed()
    },
    selectTime() {
      this.showMoreSel = true;
    },
    onConfirmMore(data) {
      this.showMoreSel = false;
      let [start,end] = data;
      this.daystartDate = this.$moment(start).format("YYYY-MM-DD");
      this.dayendDate = this.$moment(end).format("YYYY-MM-DD");
      // this.section = this.daystartDate + " 至 " + this.dayendDate;
      this.getPayed()
    },
    push(item){
      sessionStorage.setItem("payedRecipe", JSON.stringify(item));
      this.$router.push("/paymentRecordDetails");
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  background: #f9f9f9;
  overflow: auto;
  .current_user{
    position: relative;
    margin: 4px 4px 0px 4px;
    padding: 10px;
    background: #E6F5FC;
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    >li{
      >span{
        letter-spacing: 0px;
      }
    }
    >li:nth-child(2){
      margin: 10px 0px;
    }
    .switch{
      position: absolute;
      top: 10px;
      right: 20px;
      color: #6098ff;
    }
    >img{
      position: absolute;
      width: 40px;
      right: 46px;
      bottom: 10px;
    }
  }
  .content{
    .time_date {
      display: flex;
      font-size: 14px;
      padding: 12px 16px;
      color: #999;
      text-align: right;
      justify-content: flex-end;
      align-items: center;
    }
    .records{
      position: relative;
      margin: 10px 10px 0px 10px;
      padding: 10px;
      border-radius: 6px;
      background: #fff;
      font-size: 16px;
      color: #999;
      letter-spacing: 1px;
      // font-weight: bold;
      >li{
        margin-top: 4px;
        >span{
          letter-spacing: 0px;
          color: black;
        }
      }
      >li:nth-child(1){
        margin-top: 0px;
      }
      >img{
        position: absolute;
        top: 20px;
        right: 30px;
      }
    }
  }
  .empty_cl{
    text-align: center;
    >img{
      width: 100%;
    }
    >span{
      font-size: 16px;
      letter-spacing: 1px;
      color: rgba(153, 153, 153, 0.8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/paymentRecord.vue